export default __webpack_public_path__ + "static/ccl-285043f45273185b7c112fa8cbc02708.png";